import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { Size } from './models';

@Directive()
export abstract class ChartBase {
    private padding = 20; 

    private _size: Size = new Size(0, 0);
    @Output() sizeChange: EventEmitter<Size> = new EventEmitter<Size>();
    @Input()
    get size(): Size {
        return this._size;
    }
    set size(value: Size) {
        this._size = value;
        this.sizeChange.emit(this._size);
        this.updateInnerSize();
    }

    innerSize: Size = new Size(0, 0);

    private updateInnerSize(): void {
        if (this.size == undefined) {
            this.innerSize.Width = 0;
            this.innerSize.Height = 0;
        }
        else {
            this.innerSize.Width = this.size.Width - this.padding;
            this.innerSize.Height = this.size.Height - this.padding;
        }
    }

    onResize(e: any): void {
        this.size = new Size(e.width, e.height);
    }

    currentPalette: string | string[] = 'Soft';

    /**
     * Clean the color-array for leading FF characters. These values were used in the old Silverlight application, but are not supported by DevExtreme components.
     * @param colors
     */
    protected cleanColors(colors: string[]) {
        for (let i = 0; i < colors.length; i++) {
            if (colors[i].toUpperCase().startsWith("#FF") && colors[i].length > 7) {
                colors[i] = colors[i].replace('#FF', '#').replace('#ff', '#');
            }
        }
        return colors;
    }
}